import axios, { AxiosResponse } from "axios";
import { isDemo } from "@/utils";

let instance: ReportService = null;

interface ContentReportProperties {
    reason: string;
    videoUrl: string;
    reporterEmail?: string;
    reporterFirstName?: string;
    reporterLastName?: string;
    reporterMessage?: string;
}

class ReportService {
    async createReport(qrcodeId: string, properties: ContentReportProperties) {
        if (isDemo()) {
            return Promise.resolve();
        }

        try {
            const response: AxiosResponse = await axios.post("report/" + qrcodeId, properties);
            return response.data;
        } catch (e) {
            if (e?.response?.data) {
                return e.response.data;
            }

            return null;
        }
    }
}

export default function getInstance(): ReportService {
    if (!instance) {
        instance = new ReportService();
    }

    return instance;
}
